import React, { useState, createContext } from 'react';

interface SelectionOriginProps {
  children?: React.ReactNode;
}

export const SelectionOriginContext = createContext<any>({});

export const SelectionOriginProvider = ({ children }: SelectionOriginProps) => {
  const [origin, setOrigin] = useState('');
  const [id, setId] = useState('');
  const [itemCreated, setItemCreated] = useState();

  const updatePath = (originPath: string) => setOrigin(originPath);
  const updateId = (idResponse: string) => setId(idResponse);
  const updateItemCreated = (item: any) => setItemCreated(item);

  return (
    <SelectionOriginContext.Provider value={{ origin, updatePath, id, updateId, itemCreated, updateItemCreated }}>
      {children}
    </SelectionOriginContext.Provider>
  );
};
